import { LogoSection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useTranslation } from '@frontend/i18n';
import { useSettingsForm } from '../../content-composer/hooks/use-settings-form';
import { AlignmentSetting } from '../../content-composer/settings-atoms/alignment-setting';
import { FrameSetting } from '../../content-composer/settings-atoms/frame-setting';
import { HeightSetting } from '../../content-composer/settings-atoms/height-setting';
import { PaddingSetting } from '../../content-composer/settings-atoms/padding-setting';
import { SettingsPanel } from '../../content-composer/settings-panel/settings-panel';

export const LogoSettings = () => {
  const { t } = useTranslation('content-composer');

  const { getFieldProps } = useSettingsForm<LogoSection>({
    corners: { type: 'radio' },
    frame: {
      alignment: { type: 'radio' },
      backgroundColor: { type: 'text' },
      paddingTop: { type: 'text' },
      paddingBottom: { type: 'text' },
      paddingLeft: { type: 'text' },
      paddingRight: { type: 'text' },
    },
    height: { type: 'text' },
  });

  return (
    <SettingsPanel>
      <SettingsPanel.Header>{t('Logo')}</SettingsPanel.Header>
      <SettingsPanel.Body>
        <AlignmentSetting {...getFieldProps('frame', 'alignment')} />
        <HeightSetting
          {...getFieldProps('height')}
          options={['auto', '40px', '64px', '80px', '120px']}
          title={t('Logo')}
        />
        <FrameSetting {...getFieldProps('frame', 'backgroundColor')} />
        <PaddingSetting
          paddingTopFieldProps={getFieldProps('frame', 'paddingTop')}
          paddingBottomFieldProps={getFieldProps('frame', 'paddingBottom')}
          paddingLeftFieldProps={getFieldProps('frame', 'paddingLeft')}
          paddingRightFieldProps={getFieldProps('frame', 'paddingRight')}
        />
      </SettingsPanel.Body>
    </SettingsPanel>
  );
};
